export function serializeProps(props) {
    const propEntries = Object.entries(props)
        .filter(([, val]) => {
        const isValid = [
            isPrimitive(val),
            Array.isArray(val),
            Object.prototype.toString.call(val) === '[object Object]',
        ].some(Boolean);
        return isValid;
    })
        .map(([key, val]) => [key, typeof val === 'string' ? val : JSON.stringify(val)]);
    return Object.fromEntries(propEntries);
}
export function deserializeProps(params) {
    const propsEntries = Object.entries(params).map(([key, val]) => {
        return [key, deserializeProp(val)];
    });
    return Object.fromEntries(propsEntries);
}
function deserializeProp(val) {
    if (!val) {
        return val;
    }
    try {
        val = decodeURIComponent(val);
    }
    catch {
        return undefined;
    }
    const isParsable = [
        val === 'null',
        val === 'true',
        val === 'false',
        /^\d+$/.test(val),
        val.startsWith('{'),
        val.startsWith('['),
    ].some(Boolean);
    if (!isParsable) {
        return val;
    }
    try {
        return JSON.parse(val);
    }
    catch {
        // ignore
    }
}
function isPrimitive(val) {
    return typeof val === 'boolean' || typeof val === 'number' || typeof val === 'string';
}
